export default [
    {
        path: "/showfile",
        name: "ShowFile",
        meta: {
            title: "common.preview",
        },
        component: () => import("../../components/ShowTargetFile/showFile.vue"),
    },
    {
        path: "/showtext",
        name: "ShowText",
        meta: {
            title: "common.preview",
        },
        component: () => import("../../components/ShowTargetFile/showText.vue"),
    },
    {
        path: "/showvideo",
        name: "ShowVideo",
        meta: {
            title: "common.preview",
        },
        component: () => import("../../components/ShowTargetFile/showVideo.vue"),
    },
    {
        path: "/showaudio",
        name: "ShowAudio",
        meta: {
            title: "common.preview",
        },
        component: () => import("../../components/ShowTargetFile/showAudio.vue"),
    },
    {
        path: "/filePreview",
        name: "FilePreview",
        meta: {
            title: "common.preview",
        },
        component: () => import("../../components/FilePreview.vue"),
    },
];
